(function () {
    'use strict';

    run.admin.parts.csrfRefresh = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;
        const all_csrf_names = document.querySelectorAll('input[name="csrf_name"]');
        const all_csrf_values = document.querySelectorAll('input[name="csrf_value"]');

        if (csrf_name !== null && csrf_name !== 'undefined') {
            setInterval(() => {
                const newCsrfName = '';
                const newCsrfValue = '';
                for (let i = 0; i < all_csrf_names.length; i++) {
                    all_csrf_names[i].value = newCsrfName;
                }

                for (let i = 0; i < all_csrf_values.length; i++) {
                    all_csrf_values[i].value = newCsrfValue;
                }
            }, 300000); // every 5 minutes
        }
    }
})();
